import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS } from "../data/site";

export const ShowcaseBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="showcase-banner"
      className="relative bg-[#0a0a0a] overflow-hidden"
    >
      <div className="relative h-[52vh] md:h-[70vh] overflow-hidden">
        <motion.img
          src={ASSETS.truckSide}
          alt="Caminhão-guincho FS Guinchos pronto para o atendimento em Porto Alegre"
          style={{ y }}
          className="absolute inset-0 w-full h-[130%] object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/60 to-transparent" />

        <div className="relative z-10 h-full max-w-[1400px] mx-auto px-4 md:px-10 flex flex-col justify-end pb-10 md:pb-14">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
              / Nossa frota
            </span>
            <h3 className="mt-3 font-display font-bold uppercase text-white text-3xl md:text-5xl tracking-tight leading-[0.95] max-w-2xl">
              Estrutura pronta para o seu atendimento
            </h3>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
